import React from 'react'
import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider, Navigate } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'

import Home from 'page/Home/index'
import AboutUs from 'page/AboutUs/index'
import OurServices from 'page/OurServices/index'
import OurStrength from 'page/OurStrength/index'
import ContactUs from 'page/ContactUs/index'


import Main from 'page/Main'

const router = createBrowserRouter(
    createRoutesFromElements(
        <>
            <Route path='/' element={<Main />} >
                <Route index element={<Navigate to='home' replace />} />
                <Route path='home' element={<Home />} />
                <Route path='about-us' element={<AboutUs />} />
                <Route path='our-services' element={<OurServices />} />
                <Route path='our-strength' element={<OurStrength />} />
                <Route path='contact-us' element={<ContactUs />} />
            </Route>
        </>
    ),
)

export default function App() {
    const { t } = useTranslation()
    return (
        <>
            <Helmet>
                <title>{t('home.aboutTitle')}</title>
            </Helmet>
            <RouterProvider router={router} />
        </>
    )
}
